import { ACCEPTANCE_CONDITIONS } from "../constants";

export const acceptedMimeTypes = Object.keys(ACCEPTANCE_CONDITIONS.extensions)
  .map(key => ACCEPTANCE_CONDITIONS.extensions[key])
  .join(',')

export const isValidFileType = fileExt => !!ACCEPTANCE_CONDITIONS.extensions[fileExt]

export const getFilesTotalSize = files => {
  let totalSize = 0
  for (const file of files) {
    totalSize += file.size
  }
  return totalSize
}